import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    createOPDService as createOPDServiceApi,
    updateOPDService as updateOPDServiceApi,
    getAllOPDService as getAllOPDServiceApi,
    getOPDService as getOPDServiceApi,
    deleteOPDService as deleteOPDServiceApi,
    getServicesDropdown as getServicesDropdownAPI,
} from './api';

// actions
import { OPDServiceApiResponseSuccess, OPDServiceApiResponseError } from './actions';

// constants
import { OPDServicesActionTypes } from './constants';

type OPDServiceData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add OPD Service
 * @param {*}
 */
function* addOPDService({ payload, type }: OPDServiceData): SagaIterator {
    try {
        const response = yield call(createOPDServiceApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                OPDServiceApiResponseSuccess(
                    OPDServicesActionTypes.ADD_OPD_SERVICE,
                    data,
                    'OPD Service has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating OPD Service!`;
            if (message) msg = message;
            yield put(
                OPDServiceApiResponseSuccess(OPDServicesActionTypes.ADD_OPD_SERVICE, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(OPDServiceApiResponseError(OPDServicesActionTypes.ADD_OPD_SERVICE, [], error, 404, true, false));
    }
}

/**
 * Edit OPD Service
 * @param {*}
 */
function* editOPDService({ payload, type }: OPDServiceData): SagaIterator {
    try {
        const response = yield call(updateOPDServiceApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                OPDServiceApiResponseSuccess(
                    OPDServicesActionTypes.EDIT_OPD_SERVICE,
                    data,
                    'OPD Service Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit OPD Service!`;
            if (message) msg = message;
            yield put(
                OPDServiceApiResponseSuccess(OPDServicesActionTypes.EDIT_OPD_SERVICE, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(OPDServiceApiResponseError(OPDServicesActionTypes.EDIT_OPD_SERVICE, [], error, 404, true, false));
    }
}

/**
 * Get OPD Service
 * @param {*}
 */
function* getOPDService({ payload, type }: OPDServiceData): SagaIterator {
    try {
        const response = yield call(getOPDServiceApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                OPDServiceApiResponseSuccess(OPDServicesActionTypes.GET_OPD_SERVICE, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting OPD Service!`;
            if (message) msg = message;
            yield put(
                OPDServiceApiResponseSuccess(OPDServicesActionTypes.GET_OPD_SERVICE, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(OPDServiceApiResponseError(OPDServicesActionTypes.GET_OPD_SERVICE, [], error, 404, true, false));
    }
}

/**
 * Get Service Dropdown
 * @param {*}
 */
function* getServiceDropdown({ payload, type }: OPDServiceData): SagaIterator {
    try {
        const response = yield call(getServicesDropdownAPI, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                OPDServiceApiResponseSuccess(
                    OPDServicesActionTypes.GET_SERVICES_DROPDOWN,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Service Dropdown!`;
            if (message) msg = message;
            yield put(
                OPDServiceApiResponseSuccess(OPDServicesActionTypes.GET_SERVICES_DROPDOWN, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(
            OPDServiceApiResponseError(OPDServicesActionTypes.GET_SERVICES_DROPDOWN, [], error, 404, true, false)
        );
    }
}

/**
 * Get OPD Service Info
 * @param {*}
 */
function* getOPDServices({ payload, type }: OPDServiceData): SagaIterator {
    try {
        const response = yield call(getAllOPDServiceApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                OPDServiceApiResponseSuccess(
                    OPDServicesActionTypes.GET_OPD_SERVICES,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting OPD Service Info Listing!`;
            if (message) msg = message;
            yield put(
                OPDServiceApiResponseSuccess(
                    OPDServicesActionTypes.GET_OPD_SERVICES,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(OPDServiceApiResponseError(OPDServicesActionTypes.GET_OPD_SERVICES, [], error, 404, true, false));
    }
}

/**
 * Delete OPD Service
 * @param {*} payload
 */
function* DeleteOPDService({ payload, type }: OPDServiceData): SagaIterator {
    try {
        const response = yield call(deleteOPDServiceApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                OPDServiceApiResponseSuccess(
                    OPDServicesActionTypes.DELETE_OPD_SERVICE,
                    data,
                    'OPD Service Deleted Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while delete OPD Service!`;
            if (message) msg = message;
            yield put(
                OPDServiceApiResponseSuccess(OPDServicesActionTypes.DELETE_OPD_SERVICE, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(OPDServiceApiResponseError(OPDServicesActionTypes.DELETE_OPD_SERVICE, [], error, 404, true, false));
    }
}

export function* watchAddOPDService() {
    yield takeEvery(OPDServicesActionTypes.ADD_OPD_SERVICE, addOPDService);
}

export function* watchEditOPDService() {
    yield takeEvery(OPDServicesActionTypes.EDIT_OPD_SERVICE, editOPDService);
}

export function* watchGetOPDService(): any {
    yield takeEvery(OPDServicesActionTypes.GET_OPD_SERVICE, getOPDService);
}

export function* watchGetServiceDropDown(): any {
    yield takeEvery(OPDServicesActionTypes.GET_SERVICES_DROPDOWN, getServiceDropdown);
}

export function* watchGetOPDServices(): any {
    yield takeEvery(OPDServicesActionTypes.GET_OPD_SERVICES, getOPDServices);
}

export function* watchDeleteOPDService(): any {
    yield takeEvery(OPDServicesActionTypes.DELETE_OPD_SERVICE, DeleteOPDService);
}

function* OPDServiceSaga() {
    yield all([
        fork(watchAddOPDService),
        fork(watchEditOPDService),
        fork(watchGetOPDService),
        fork(watchGetOPDServices),
        fork(watchDeleteOPDService),
        fork(watchGetServiceDropDown),
    ]);
}

export default OPDServiceSaga;
